module.exports = __webpack_public_path__ + "media/images/application2/AppMfaIdentityVerification__dl__item--0-d68d32758f76f618a7a5bf4d95116e85.svg";